// Copyright 2019 Fastcastcity Inc. All Rights Reserved.

/**
 * @fileoverview File for tracking configuration key/value pairs for esri and fastcast services.
 *
 * @author sabir.shrestha@gmail.com (Sabir Shrestha)
 */

/**
 * Esri related config
 *
 */
const esriConfig = {
    portal: 'GeodesySF',
    proxyUrl: 'https://geodesy.net/PHP/proxy.php',
    serviceUrlRoot: 'https://services7.arcgis.com/hk2QinczWjz8bTrR/arcgis/rest/services',
    urlRoot: 'https://www.arcgis.com/sharing/rest'
};

/**
 * Fastcast related config
 *
 */
const fastcastConfig = {
    authBaseUrl: 'https://auth.fastcastcity.net',
    serviceBaseUrl: 'https://service.fastcastcity.net'
};

module.exports = {
    esri: esriConfig,
    fastcast: fastcastConfig
};
